// extracted by mini-css-extract-plugin
module.exports = {"btn-warapper":"common_btn-warapper__HSuf0","btn-submit":"common_btn-submit__pEPDd","btn-back":"common_btn-back__2_zsR"};